/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { CommonService } from './shared/services/common.service';
import { tap, catchError } from 'rxjs/operators';
import { LicenseManager } from "ag-grid-enterprise";

@Injectable({
  providedIn: 'root'
})
export class AgGridLicenseResolver implements Resolve<any> {

  constructor(private commonService: CommonService) {}

  resolve(): Observable<any> {

    return this.commonService.getAgGridLicenseKey().pipe(
      tap((res) => {
        if (res && res.number) {
          LicenseManager.setLicenseKey(res.number);
          console.log('ag-Grid License Key Set successfully');
        } else {
          console.warn('ag-Grid License Key Not Found');
        }
      }),
      catchError((error) => {
        console.error('Failed to fetch ag-Grid License Key', error);
        return of(null);
      })
    );
  }
}
